import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';
import PasswordInput from '../../../common/input/password-input/PasswordInput';
import PasswordValidation from '../../../common/validation/password-validation/PasswordValidation';

import './reset-password.scss';

type Props = {
  resetPassword: (password: string, callback: () => void) => void;
};

const ResetPassword = ({ resetPassword }: Props) => {
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [passwordReset, setPasswordReset] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  const navigate = useNavigate();

  const renderFields = () => (
    <>
      <p className="reset-password__message">Please enter your new password:</p>
      <div className="reset-password__input-container">
        <PasswordInput value={password} onChange={({ target }) => setPassword(target.value)} placeholder="password" />

        <PasswordInput
          value={confirmationPassword}
          onChange={({ target }) => setConfirmationPassword(target.value)}
          placeholder="confirm password"
        />

        <PasswordValidation
          password={password}
          confirmationPassword={confirmationPassword}
          setValidPassword={setValidPassword}
        />
      </div>

      <div className="reset-password__button-container">
        <Button
          text="Reset Password"
          disabled={!validPassword}
          onClick={() => resetPassword(password, () => setPasswordReset(true))}
          auth
        />
      </div>
    </>
  );

  return (
    <AuthLayout>
      <div className="reset-password">
        {passwordReset ? (
          <>
            <div className="reset-password__success-message-container">
              <p className="reset-password__message">Thank you.</p>
              <p className="reset-password__message">Your password has been reset.</p>
            </div>
            <div className="reset-password__button-container">
              <Button text="Return Home" onClick={() => navigate('/')} auth />
            </div>
          </>
        ) : (
          renderFields()
        )}
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
